import {SubmitButton} from "@unibuddy/patron";

export default SubmitButton;
